import { render } from "./new-carousel-skeleton.vue?vue&type=template&id=66d5984c&scoped=true"
import script from "./new-carousel-skeleton.vue?vue&type=script&lang=js"
export * from "./new-carousel-skeleton.vue?vue&type=script&lang=js"

import "./new-carousel-skeleton.vue?vue&type=style&index=0&id=66d5984c&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d5984c"]])

export default __exports__